"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnFilterLogicOperatorSchema = void 0;
const zod_1 = require("zod");
exports.columnFilterLogicOperatorSchema = zod_1.z.enum(['and', 'or']);
//# sourceMappingURL=query-builder-helpers.js.map